<template>
    <div id="job_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="roleHeader" v-if="$route.params.id > 0">Update Job</span>
                    <span class="page-title" id="roleHeader" v-else>Add Job</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackJobList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content job-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="JobPostingForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Job ID:</label>
                                        <input type="text" class="form-control" v-model="job_id" id="job_id" placeholder="Enter Job ID" name="job_id">
                                        <div class="field-error">{{job_id_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Title:</label>
                                        <input type="text" class="form-control" v-model="job_title" id="title" placeholder="Enter Title" name="job_title">
                                        <div class="field-error">{{job_title_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label require">Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="job_date" name="job_date" v-model="job_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="job_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{job_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="due_out_location_id">Location:</label>
                                        <v-select v-model="job_location" name="job_location" placeholder="Select Job Location."
                                                label="text"
                                                :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{job_location_error_msg}}</div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="control-label require" for="name">URL:</label>
                                        <input type="text" class="form-control" v-model="job_url" id="job_url" placeholder="Enter URL" name="job_url">
                                        <div class="field-error">{{job_url_error_msg}}</div>
                                    </div>
                                </div>
                                    <div class="form-row row-cols-md-5 row-cols-5">
                                        <div class="col-md-12 form-group">
                                            <label class="control-label require" for="name">Description:</label>
                                            <template>
                                                <div id="app">
                                                    <vue-editor v-model="job_description"></vue-editor>
                                                </div>
                                                <div class="field-error">{{job_description_error_msg}}</div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="alert alert-warning hide col-sm-6" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="field-error"></strong>
                                        </div>
                                    </div>
                                    <div class="btn-groups">
                                        <button type="submit" id="createJobBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateJob">
                                        <i class="fp-reload"> </i>  Update
                                        </button>
                                        <button type="submit" id="createJobBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateJob" >
                                        <i class="fp-save"> </i>  Save
                                        </button>
                                        <button type="submit" id="createAndContinueJobBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateJob(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                        </button>
                                        <button type="submit" id="cancelJobBtn" class="btn btn-tertiary" v-on:click.prevent="BackJobList">
                                        <i class="fp-close"> </i>  Cancel
                                        </button>
                                    </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import { VueEditor } from "vue2-editor";

// Advanced Use - Hook into Quill's API for Custom Functionality
// import { VueEditor, Quill } from "vue2-editor";


export default {
  name: "JobCreate",
  components: {
        VueEditor
    },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    job_title: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    loading:false,
    permissions: [],
    cantAccessPage: "",
    job_title_error_msg: "",
    job_description:'',
    job_url:'',
    job_url_error_msg:'',
    job_description_error_msg:'',
    job_location:'',
    locationArr:[],
    job_id:'',
    job_id_error_msg:'',
    job_location_error_msg:'',
    job_date_error_msg:'',
    job_date:'',
  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_news' ) {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
         setTimeout(function () {
            self.loadFieldData(['job_locations']);
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadJob();

            }
        }, 100);
  },
  methods: {

    BackJobList() {
      var self = this;
      self.$router.push("/job-posting/list");
    },

    CreateJob(flag) {
      var self = this;

      self.job_title_error_msg = "";
      self.job_description_error_msg = '';
      self.job_id_error_msg = '';
      self.job_url_error_msg = '';
      self.job_location_error_msg = '';
      self.job_date_error_msg = '';

      var error = false;
      var fields = $("#JobPostingForm").serializeArray();

      if (!self.job_title || self.job_title == null || self.job_title == "") {
        self.job_title_error_msg = "Job Title Required.";
        error = true;
      }

      if (!self.job_description || self.job_description == null || self.job_description == "") {
        self.job_description_error_msg = "Job Description Required.";
        error = true;
      }
      if (!self.job_id || self.job_id == null || self.job_id == "") {
        self.job_id_error_msg = "Job ID Required.";
        error = true;
      }
      if (!self.job_url || self.job_url == null || self.job_url == "") {
        self.job_url_error_msg = "Job Url Required.";
        error = true;
      }
      if (!self.job_date || self.job_date == null || self.job_date == "") {
        self.job_date_error_msg = "Job Date Required.";
        error = true;
      }
      if (!self.job_location || self.job_location == null || !self.job_location.value) {
        self.job_location_error_msg = "Job Location Required.";
        error = true;
      }


        if (!error){

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createJobBtn").val("Updating ...");
                $("#createJobBtn").prop("disabled", true);
                $("#cancelJobBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueJobBtn").val("Saving ...");
                    $("#createJobBtn").prop("disabled", true);
                    $("#createAndContinueJobBtn").prop("disabled", true);
                    $("#cancelJobBtn").prop("disabled",true);

                }else{

                    $("#createJobBtn").val("Saving ...");
                    $("#createJobBtn").prop("disabled", true);
                    $("#createAndContinueJobBtn").prop("disabled", true);
                    $("#cancelJobBtn").prop("disabled",true);
                }

            }

            fields.push({
                name:"job_location",
                value:self.job_location.value
            });
             fields.push({
                name:"job_description",
                value:self.job_description
            });


            if (segments[3]){
                fields.push({
                name:"id",
                value:segments[3]
                });
            }else{
                fields.push({
                name:"id",
                value:0
                });
            }

            $.ajax({
                url: process.env.ROOT_API + "/job/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createJobBtn").val("Update");
                        $("#createJobBtn").prop("disabled", false);
                        $("#cancelJobBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueJobBtn").val("Save and Continue");
                            $("#createJobBtn").prop("disabled", false);
                            $("#createAndContinueJobBtn").prop("disabled", false);
                            $("#cancelJobBtn").prop("disabled",false);

                        }else{

                            $("#createJobBtn").val("Save");
                            $("#createJobBtn").prop("disabled", false);
                            $("#createAndContinueJobBtn").prop("disabled", false);
                            $("#cancelJobBtn").prop("disabled",false);
                        }

                    }
                    if (data.status == "exist") {

                        var err = data.message;

                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);

                        return;
                    }

                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.job_title = '';
                            self.job_id = '';
                            self.job_description = '';
                            self.job_date = '';
                            self.job_url = '';
                            self.job_location = '';

                        }else{
                            self.$router.push("/job-posting/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createJobBtn").val("Update");
                        $("#createJobBtn").prop("disabled", false);
                        $("#cancelJobBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueJobBtn").val("Save and Continue");
                            $("#createJobBtn").prop("disabled", false);
                            $("#createAndContinueJobBtn").prop("disabled", false);
                            $("#cancelJobBtn").prop("disabled",false);

                        }else{

                            $("#createJobBtn").val("Save");
                            $("#createJobBtn").prop("disabled", false);
                            $("#createAndContinueJobBtn").prop("disabled", false);
                            $("#cancelJobBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadJob() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/job/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.job_title = data.content.job_title;
                    self.job_id = data.content.job_id;
                    self.job_description = data.content.job_description;
                    self.job_date = data.content.job_date;
                    self.job_url = data.content.job_url;
                    self.job_location = {text:data.content.company_name+'('+data.content.code+')',value:data.content.job_location};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    handleFilesUpload: function(event) {
        /* Get the uploaded files from the input.*/

        var self = this;
        self.filesArr = [];
        self.fileerroor_msg = "";

        let uploadedFiles = "";
        self.uploadBtn= "Uploading...";
        uploadedFiles = self.$refs.files.files;
        for (var i = 0; i < uploadedFiles.length; i++) {

            this.filesArr.push(uploadedFiles[i]);

        }
        console.log(this.filesArr);
        this.$refs.files.value = '';
        self.uploadBtn= "Upload";
     },
     deleteDoc: function(id,key) {
          var self = this;

          if (confirm('Are you sure that you want to remove file? ')) {

                self.submitBtn = false;
                console.log( self.$refs.files);
                this.filesArr.splice(key,1)
                self.$refs.files.value = '';
                if (self.valuesFound) {
                    self.valuesFound = false;
                    self.matchingValuesError = [];
                }
          }
          return;

      },

     deleteNewsFile: function(key,file){
         var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        var newsId = segments[3];

        if (confirm('Are you sure that you want to remove file? ')) {

            if ( newsId != '' && newsId != undefined ) {

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/remove-news-file",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        news_id:newsId,
                        doc_path:file
                    },
                    success: function(data) {
                        self.loading = false;
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {

                            self.loadNews();
                            // $("#myModal").modal("hide");
                            self.$refs.files.value = '';
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.files.splice(key,1);
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            } else{

                self.filesArr.splice(key,1);
                self.$refs.files.value = '';
            }
        }

     }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/JobPostingCreate.vue